import { useState } from 'react';
import { api } from '../../lib/api';
import { useGym } from '../../lib/gym';
import { useApi } from '../../lib/hooks';
import { useI18n } from '../../lib/i18n';
import { AsyncButton, Card, cx, ErrorBox, Loading, Textarea } from '../../ui/components';
import { Brand, TestModeBanner } from '../../ui/layout';

/** One question after a number of visits: how likely would you recommend us? */
export function FeedbackPage({ token }: { token: string }) {
  const gym = useGym();
  const i18n = useI18n();
  const state = useApi(() => api(`/v1/public/${gym.slug}/feedback/${token}`), [token]);
  const [score, setScore] = useState<number | null>(null);
  const [comment, setComment] = useState('');
  const [done, setDone] = useState<{ group: string; reviewUrl: string | null } | null>(null);

  return (
    <div className="public">
      <TestModeBanner />
      <header className="public-head"><Brand /></header>
      <main className="public-main narrow">
        {state.error ? <ErrorBox error={state.error} /> : !state.data ? <Loading /> : done ? (
          <Card>
            <h1>{i18n.t('feedback.thanks')}</h1>
            {done.group === 'promoter' && done.reviewUrl && (
              <>
                <p>{i18n.t('feedback.review_ask')}</p>
                <a className="btn btn-primary btn-lg" href={done.reviewUrl} target="_blank" rel="noreferrer">{i18n.t('feedback.review_button')}</a>
              </>
            )}
            {done.group !== 'promoter' && <p>{i18n.t('feedback.we_call')}</p>}
          </Card>
        ) : state.data.answered ? (
          <Card><h1>{i18n.t('feedback.already')}</h1></Card>
        ) : (
          <Card>
            <h1>{i18n.t('feedback.question', { gym: state.data.gym })}</h1>
            <div className="scores">
              {Array.from({ length: 11 }, (_, n) => (
                <button type="button" key={n} className={cx('score', score === n && 'active')} onClick={() => setScore(n)}>{n}</button>
              ))}
            </div>
            <div className="row between small muted"><span>{i18n.t('feedback.not_likely')}</span><span>{i18n.t('feedback.very_likely')}</span></div>
            {score !== null && (
              <>
                <Textarea rows={3} value={comment} placeholder={i18n.t(score >= 9 ? 'feedback.what_good' : 'feedback.what_better')} onChange={(e) => setComment(e.target.value)} />
                <AsyncButton size="lg" onClick={async () => setDone(await api(`/v1/public/${gym.slug}/feedback/${token}`, { body: { score, comment } }))}>
                  {i18n.t('feedback.send')}
                </AsyncButton>
              </>
            )}
          </Card>
        )}
      </main>
    </div>
  );
}
